import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Divider, Typography } from '@material-ui/core';
import api from 'src/api/api';
import { HEADERS } from 'src/constants/headers';
import { CallItem } from '../../Calls';
import { useTranslation } from 'react-i18next';

type ContactCallHistoryProps = {
    contactId?: string;
    conversationId: string;
};

export const ContactCallHistory = ({
    contactId,
    conversationId,
}: ContactCallHistoryProps) => {
    const [calls, setCalls] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true;
        const filters = contactId
            ? {
                $or: [
                    { contact: contactId },
                    { warboxConversation: conversationId },
                ],
            }
            : { warboxConversation: conversationId };

        setLoading(true);
        api.post(
            '/calls',
            { ...filters, page: 1, limit: 50 },
            HEADERS()
        )
            .then(({ data }) => {
                if (mounted) setCalls(data.data || []);
            })
            .catch(() => {
                if (mounted) setCalls([]);
            })
            .finally(() => {
                if (mounted) setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, [contactId, conversationId]);

    return (
        <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
            <Typography variant="h4" color="textPrimary">
                {t('Chat.CallHistory')}
            </Typography>
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />

            {loading ? (
                <Box display="flex" justifyContent="center" py={3}>
                    <CircularProgress size={28} />
                </Box>
            ) : calls.length === 0 ? (
                <Typography
                    variant="body1"
                    color="textSecondary"
                    align="center"
                >
                    {t('Chat.NoCallsRegistered')}
                </Typography>
            ) : (
                <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
                    {calls.map((call) => (
                        <CallItem key={call._id} call={call} />
                    ))}
                </Box>
            )}
        </Box>
    );
};
